<template>
  <div>
    <v-layout align-center justify-center fill-height id="edit-advert">
      <!-- <v-flex xs12 v-show="!authenticated">

			<preferences-auth-info>
				<v-tabs v-model="active_tab" grow>
					<v-tabs-slider></v-tabs-slider>
					<v-tab>{{ trans('app.sign_up') }}</v-tab>
					<v-tab>{{ trans('app.sign_in') }}</v-tab>
					<v-tab-item :key="0">
						<auth mode="sign_up"></auth>
					</v-tab-item>
					<v-tab-item :key="1">
						<auth mode="sign_in"></auth>
					</v-tab-item>
				</v-tabs>
			</preferences-auth-info>

      </v-flex>-->

      <v-flex xs12 v-show="authenticated">
        <div class="text-center py-5 my-5" v-if="!instance_loaded">
          <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>

        <stepper
          v-show="instance_loaded"
          :schema="schema_grouped"
          :user="userProfile"
          :editable="uuid != null"
          ref="stepper"
          @change="stepChanged"
          @reload="load"
          @input="updateInstance"
          @save="saveData"
        ></stepper>
      </v-flex>
    </v-layout>

    <!-- <v-btn
      v-show="authenticated"
      color="primary"
      :loading="saving"
      :disabled="!can_save"
      :depressed="!can_save"
      :light="!can_save"
      @click="submit"
      fixed
      fab
      bottom
      right
    >
      <v-icon>mdi-check</v-icon>
    </v-btn>

    <v-btn v-show="authenticated" color="secondary" @click="cancel" fixed fab bottom right>
      <v-icon>mdi-close</v-icon>
    </v-btn>-->
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import LocationDrawable from "../ui/custom/LocationDrawable";
import Auth from "../components/Auth";
import PreferencesAuthInfo from "../components/PreferencesAuthInfo";
import Stepper from "../components/Stepper";

export default {
  components: {
    auth: Auth,
    "preferences-auth-info": PreferencesAuthInfo,
    stepper: Stepper
  },
  data: () => ({
    active_tab: 0,
    can_save: false,
    is_dirty: false,
    auto_description_parts: {},
    auto_description_verbs: []
  }),

  computed: {
    ...mapState("auth", {
      authenticated: "authenticated"
    }),
    ...mapState("user", {
      userProfile: "instance"
    }),
    ...mapState("preferences", {
      initial_schema: "schema",
      instance: "instance",
      instance_loaded: "instance_loaded",
      loading: "instance_loading",
      saving: "instance_saving",
      instance_saved: "instance_saved"
    }),
    ...mapGetters({
      getError: "errors/get",
      hasError: "errors/has"
    }),

    uuid: function() {
      return _.get(this.$route.params, "uuid", null);
    },

    schema: function() {
      return _.map(this.initial_schema, config => {
        config = Object.assign({}, config);

        if (config.id == "location") {
          config.size = { cols: 12 };
          config.view = LocationDrawable;
        }
        if (config.id == "property_type") {
          config.size = { cols: 12, sm: 12 };
        }
        if (
          config.id == "title" ||
          config.id == "description" ||
          config.id == "images"
        ) {
          config.size = { cols: 12, sm: 12 };
        }
        if (config.id == "price_max") {
          config.suffix =
            "\xa0\xa0" +
            this.trans("advert.price_currency_usd") +
            " / " +
            this.trans("advert.rent_period_month");
          config.size = { cols: 12, md: 6 };
        }
        if (config.id == "price_currency") {
          config.presentation = "hidden";
        }

        return config;
      });
    },

    schema_grouped: function() {
      let fieldset = {};
      for (let i in this.schema) {
        let fieldset_id = this.schema[i].group;
        if (!fieldset[fieldset_id]) fieldset[fieldset_id] = [];
        fieldset[fieldset_id].push(this.schema[i]);
      }
      return fieldset;
    },

    steps: function() {
      return this.schema_grouped;
    },

    profile_filled: function() {
      return _.get(this.userProfile, "filled", false);
    }
  },

  methods: {
    ...mapActions("preferences", {
      create: "create",
      edit: "edit",
      store: "store",
      update: "update",
      updateInstance: "updateInstance",
      resetInstance: "resetInstance"
    }),
    ...mapActions("errors", {
      clearErrors: "clear"
    }),
    ...mapActions("user", {
      loadProfile: "edit"
    }),

    load: function() {
      if (this.uuid) {
        this.edit(this.uuid);
      } else {
        this.create();
      }
    },

    submit: function() {
      this.$refs.stepper.save();
    },

    cancel: function() {
      if (this.authenticated) {
        this.$router.push({ name: "my-preferences" });
      } else {
        this.$router.push({ name: "home" });
      }
    },

    // +
    stepChanged: function(step) {
      if (this.$refs.stepper) {
        this.can_save = this.$refs.stepper.can_save;
      }

      if (step >= 3) {
        var {
          occupants_amount,
          tenant_gender,
          tenant_age,
          room_size,
          available_from,
          price_max,
          property_type,
          flatmate_gender,
          flatmate_age_min,
          flatmate_age_max
        } = Object.assign({}, this.instance);

        let parts = [];

        if (occupants_amount == 1) {
          parts.push("I am");
          if (tenant_gender == "male") parts.push(`a male`);
          if (tenant_gender == "female") parts.push(`a female`);
        } else {
          parts.push(`We are a group of ${occupants_amount}`);
          if (tenant_gender == "male") parts.push(`males`);
          if (tenant_gender == "female") parts.push(`females`);
          if (tenant_gender == "mixed") parts.push(`people`);
        }
        if (tenant_age) {
          parts.push(`aged ${tenant_age}`);
        }
        parts.push("looking for");
        if (property_type == "room") {
          if (room_size == "single") {
            parts.push(`a single room`);
          } else if (room_size == "double") {
            parts.push(`a double room`);
          } else {
            parts.push(`a single or double room`);
          }
        } else {
          parts.push(`an apartment`);
        }
        parts.push(".");
        parts.push("I am available to move");
        if (available_from) {
          parts.push(`from ${available_from}`);
        } else {
          parts.push(`at any time`);
        }
        if (price_max) {
          parts.push(`and have a budget of ${price_max}$`);
        }
        parts.push(".");
        if (property_type == "room") {
          parts.push(`I would like to share with`);
          if (flatmate_gender == "male") {
            parts.push(`males`);
          } else if (flatmate_gender == "female") {
            parts.push(`females`);
          } else {
            parts.push(`males or females`);
          }
          parts.push(`of age ${flatmate_age_min}-${flatmate_age_max}`);
        }

        // this.auto_description_verbs = parts;

        var str = parts.join(" ");
        str = str.replace(/\s\./g, ".");
        var str_short = str.substring(0, 117) + "...";

        if (!this.instance.title) {
          this.updateInstance({ title: str_short });
        }
        if (!this.instance.description) {
          this.updateInstance({ description: str });
        }
      }
    },

    saveData: function() {
      if (this.uuid) {
        this.update(this.uuid);
      } else {
        this.store();
      }
    }
  },

  mounted: function() {
    this.resetInstance();
    this.load();
    this.clearErrors();

    if (this.authenticated) {
      this.loadProfile();
    }

    this.$store.subscribe(({ type, payload }, state) => {
      if (type == "preferences/handleStatus") {
        if (
          state.preferences.instance_saving == true &&
          payload.instance_saved == true
        ) {
          this.$router.push({ name: "my-preferences" });
        }
      }
      if (type == "preferences/handleUpdateInstance") {
        this.is_dirty = true;
      }
      if (type == "auth/login") {
        this.resetInstance();
        this.load();
        this.clearErrors();
        this.loadProfile();
      }
      // Chrome mobile fix on field update.
      if (type == "preferences/handleSchemaLoaded") {
        if (this.$refs.stepper) {
          const cs = this.$refs.stepper.current_step;
          this.$refs.stepper.current_step = 0;
          this.$nextTick(function() {
            this.$refs.stepper.current_step = cs;
          });
        }
      }
    });

    // Fix: https://app.asana.com/0/1139276334135489/1146185789452753
    // "warning about unsaved data appears where it shouldn't"
    if (this.authenticated) {
      window.onbeforeunload = e => this.trans("app.confirm_leave_page");
    }
  },

  beforeRouteLeave(to, from, next) {
    // Fix: https://app.asana.com/0/1139276334135489/1146185789452753
    // "warning about unsaved data appears where it shouldn't"
    if (
      this.instance_saved == false &&
      this.is_dirty == true &&
      this.authenticated
    ) {
      const answer = window.confirm(this.trans("app.confirm_leave_page"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

  beforeDestroy() {
    window.onbeforeunload = () => {};
    this.resetInstance();
  }
};
</script>